import userReducer from "../user-reducer/userStateReducerAction";
import restaurantReducer from "../restaurant-reducer/restaurantReducer";

const redux = require("redux");
const combineReducers = redux.combineReducers;

const rootReducer = combineReducers({
  restaurantReducer: restaurantReducer,
  userReducer: userReducer,
});

export default rootReducer;
